import * as yup from 'yup';
import { Fields } from '../models/fields';
import { useTranslation } from '~/shared/utils/translation';
import { passwordRegex } from '~/shared/utils';
import { isGender, isPhoneWithoutCountryCode, isWord } from '~/utils/form-validators';

/**
 * Yup documentaion https://github.com/jquense/yup
 * @returns validation schema
 */

export const useValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        [Fields.FirstName]: yup.string().required('').trim().matches(isWord),
        [Fields.LastName]: yup.string().required('').trim().matches(isWord),
        [Fields.Mobile]: yup
            .string()
            .required('')
            .max(8, translate('message.phoneValidationError'))
            .matches(isPhoneWithoutCountryCode, translate('message.phoneValidationError')),
        [Fields.Gender]: yup
            .string()
            .required(translate('message.genderValidationError'))
            .matches(isGender, translate('message.genderValidationError'))
            .trim(),
        [Fields.Birthday]: yup
            .date()
            .nullable()
            .required('')
            .default(undefined)
            .min('1900-01-01', translate('message.incorrectDate'))
            .max(new Date(), translate('message.dateCannotBeInFuture'))
            .typeError(translate('message.incorrectDate'))
            .transform((curr, orig) => {
                return orig === '' ? null : curr;
            }),
        [Fields.Email]: yup.string().email(translate('message.emailValidationError')).required(''),
        [Fields.RepeatEmail]: yup
            .string()
            .email(translate('message.emailValidationError'))
            .required('')
            .oneOf([yup.ref(Fields.Email), null], translate('createAccount.emailMismatch')),
        [Fields.CreateAccountConsent]: yup.boolean().when(Fields.CreateAccount, {
            is: true,
            then: yup.boolean().oneOf([true], '').required(''),
        }),

        /**/
        [Fields.Password]: yup.string().when(Fields.CreateAccount, {
            is: true,
            then: yup
                .string()
                .required('')
                .matches(passwordRegex, translate('message.passwordHelpText')),
        }),
    });
};
